module.exports = __webpack_public_path__ + "bgm-intro.9906f783.mp3";